import React, { useEffect } from "react";
import { useMe } from "../actions/auth";
import { saveUser, clearAuthIntent } from "../_helpers/auth";
import log from "cslog";
import { history } from "../_helpers/history";
import AppSplash from "../common/AppSplash";

function AutoLogin({ enable, children }) {
    const {
        isLoading: loadingMe,
        isSuccess: successMe,
        isError: errorMe,
        data: dataMe,
    } = useMe(enable);

    const sendHome = () => {
        const { from } = history.location.state || {
            from: { pathname: "/" },
        };
        history.push(from);
    };

    useEffect(() => {
        if (successMe) {
            saveUser(dataMe);
        }
        if (enable && successMe && !loadingMe && dataMe?.data !== undefined) {
            log.p("Sending home after auto-login");
            sendHome();
        }
    }, [successMe, loadingMe, dataMe, enable]);

    useEffect(() => {
        if (enable && errorMe) {
            log.p("Auto-login failed — clearing auth intent");
            clearAuthIntent();
        }
    }, [enable, errorMe]);

    if (enable && loadingMe) {
        return <AppSplash msg="Auto logging in..." />;
    }

    return <>{children}</>;
}

export default AutoLogin;
